import { useEffect, useState } from "react";
import bookingApi from "../../api/booking/booking";
import { ui } from "../../helpers/ui";

const InitCancellationsLogic = () => {
  const [summary, setSummary] = useState<any>({
    months: [],
    byClient: [],
    byTrainer: [],
    selectedMonth: null,
  });
  const [rows, setRows] = useState<any[]>([]);
  const [month, setMonth] = useState<string>(""); // "" = sve od pocetka
  const [loading, setLoading] = useState<boolean>(true);

  const load = (m: string) => {
    setLoading(true);
    Promise.all([
      bookingApi.getCancellationsSummary(m || undefined),
      bookingApi.getCancellations({ month: m || undefined, limit: 300 }),
    ])
      .then(([s, l]) => {
        if (s.status === 200) setSummary(s.data);
        if (l.status === 200) setRows(l.data);
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load(month);
  }, [month]);

  return { summary, rows, month, setMonth, loading };
};

export default InitCancellationsLogic;
